import React from 'react'
import AddDepartmentForm from '../../../component/form/master/department/AddDepartmentForm'

export default function AddDepartment() {
    return (
        <>
            <div className='container-fluid'>
                <div className="row">
                    <div className="col-md-12">
                        <AddDepartmentForm />
                    </div>
                </div>
            </div>
        </>
    )
}
